import { withApolloProvider } from "providers/ApolloClientProvider";
import "./index.scss";
import { GRAPHQL_CMS_BASE_URL } from "constants/endpoints";
import { useGetCampaigns } from "./utils/useGetCampaigns";
import { CampaignSlider } from "../campaign-slider";
import { HomeContainer, Skeleton } from "components/UI/atoms";

const HomeCampaigns = () => {
  const { campaigns, loading } = useGetCampaigns();

  return (
    <HomeContainer>
      <div className="home-campaigns">
        {loading && <Skeleton height="200px" />}
        {!loading &&
          campaigns.map((item) => (
            <CampaignSlider
              key={item.title}
              brands={item.brands}
              title={item.title}
            />
          ))}
      </div>
    </HomeContainer>
  );
};

export default withApolloProvider(HomeCampaigns, {
  graphqlEndpoint: GRAPHQL_CMS_BASE_URL
});
